/**
 * Typed form of the server's `409 { code: "StatusNotEmpty", taskCount }` answer to a column delete
 * (Task 6). The store throws it so the board can open the move-tasks modal instead of a toast.
 */
export class StatusNotEmptyError extends Error {
  readonly taskCount: number;

  constructor(taskCount: number) {
    super(`Status still has ${taskCount} task(s)`);
    this.name = 'StatusNotEmptyError';
    this.taskCount = taskCount;
    // Keeps `instanceof` working when the class is down-levelled to ES5 in the production build.
    Object.setPrototypeOf(this, StatusNotEmptyError.prototype);
  }
}

type AxiosLike = { response?: { status?: number; data?: { code?: string; taskCount?: unknown } | null } };

export function toStatusNotEmptyError(error: unknown): StatusNotEmptyError | null {
  const response = (error as AxiosLike | null | undefined)?.response;
  if (response?.status !== 409 || response.data?.code !== 'StatusNotEmpty') {
    return null;
  }
  const count = Number(response.data?.taskCount);
  return new StatusNotEmptyError(Number.isFinite(count) ? count : 0);
}

export function isStatusNotEmptyError(error: unknown): error is StatusNotEmptyError {
  return error instanceof StatusNotEmptyError
    || (error as { name?: string } | null | undefined)?.name === 'StatusNotEmptyError';
}
